import { ConfigProvider } from "antd";
import "./App.css";
import MainRoutes from "./router/route";
import { theme } from "./theme/Theme";
import { UserProvider } from "./context/User.context";
import { LanguageProvider } from "./context/Language.contex";

function App() {
  return (
    <div className="App">
      <UserProvider>
        <LanguageProvider>
          <ConfigProvider theme={theme}>
            <MainRoutes />
          </ConfigProvider>
        </LanguageProvider>
      </UserProvider>
    </div>
  );
}

export default App;
